<template>
  <div v-if="shown" class="modal-wrapper">
    <div :class="classes">
      <div class="m-header">
        <div class="header">
          <h2 class="text-center">{{ title }}</h2>
        </div>
      </div>

      <div class="m-body">
        <slot></slot>
      </div>

      <div class="close-modal" @click="onCloseModalClick">
        x
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-wrapper',
  props: {
    shown: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: 'modal-container',
    },
  },
  data() {
    return {
      headerElement: document.getElementById('masthead'),
    };
  },
  methods: {
    onCloseModalClick() {
      this.$emit('close-modal');
    },
    hidePageHeaderAndScrollbar() {
      this.headerElement.style.display = 'none';
      document.body.style.overflow = 'hidden';
    },
    showPageHeaderAndScrollbar() {
      this.headerElement.style.display = 'block';
      document.body.style.overflow = null;
    },
  },
  watch: {
    shown: {
      immediate: true,
      handler(shown) {
        if (shown) {
          this.hidePageHeaderAndScrollbar();
        } else {
          this.showPageHeaderAndScrollbar();
        }
      },
    },
  },
  beforeDestroy() {
    this.showPageHeaderAndScrollbar();
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
    background: rgb(102, 204, 204);
    cursor: initial;
    position:fixed;
    top:0;
    left:0;
    z-index:1000000;
    height:100%;
    width:100%;
}

.modal-container {
    margin: 0 auto;
    max-width:960px;
    width:100%;
    height:100%;
    padding: 100px 0 0 0;
}

.header h2 {
    color:#fff;
}

.close-modal {
    position:absolute;
    top: 0;
    right:35px;
    color:#777;
    font-size: 50px;
    font-weight:bold;
    cursor:pointer;
    transition: 350ms ease all;
}

.close-modal:hover {
    color:#333;
}
</style>
